export const ROOM_PATH = 'room';
export const INTERVIEW_SESSION_PATH = '/interview-session';
